import { Injectable } from '@angular/core';
import { GridOptions } from 'ag-grid';

@Injectable()
export class GridExportServiceMock {
    constructor() { }

    public initiateExportCallWithServiceEndpoint(dataServiceURL: string, exportConfig: any,
                                                 downloadExtension: string, fileName?: string): void {}

    public initiateExportCallWithCSVData(gridOptions: GridOptions, exportConfig: any,
                                         downloadExtension: string, fileName?: string): void { }

    public initiateExportCallWithJSONData(jsonString: string, exportConfig: any,
                                          downloadExtension: string, fileName?: string): void { }
}
